import React, { useEffect, useState } from "react";
import {
  FormControl,
  Select,
  MenuItem,
  CircularProgress,
  InputLabel,
} from "@material-ui/core";
import * as api from "../forecastApi";

export default function MFGPlantSelect({ value, onChange }) {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const ctrl = new AbortController();
    setLoading(true);
    api
      .fetchMfgPlants(ctrl.signal)
      .then((res) => {
        if (res && res.status) {
          setOptions(res.MfgPlantsDetails || []);
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
    return () => ctrl.abort();
  }, []);

  const handleChange = (e) => {
    onChange(e.target.value || null);
  };

  return (
    <FormControl fullWidth>
      <InputLabel shrink>Select MFG Plant ID</InputLabel>
      <Select
        displayEmpty
        value={value || ""}
        onChange={handleChange}
        disabled={loading}
      >
        <MenuItem value="">
          {loading ? <CircularProgress size={16} /> : "All"}
        </MenuItem>
        {options.map((opt) => (
          <MenuItem key={opt.aslNumber} value={opt.aslNumber}>
            {opt.mfgPlantShortName || opt.aslNumber}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
